<div class="container-fluid">
  <div class="col-12 main_container">
    <div class="unlicensedContainer">
      <div class="form_center">
        <div class="imagoLogin">
          <img src="/assets/menu/enterprise/logo-enterprise.svg" alt="Enterprise Logo" />
        </div>

        <h2 class="loginProjectTitle">No Active License</h2>

        <div class="unlicensed-message-box">
          <p class="description">
            Your account does not have an active license for this Feature. Please contact your system administrator
            or support team to assign a license to your account.
          </p>
        </div>

        <div class="centerDisplay actions">
          <button (click)="goBack()" class="btn btn-primary commonBouttonStyle returnBtn">
            <span>
              <img class="loginIcons" src="/assets/menu/enterprise/back-icon.svg" />
            </span>
            Return
          </button>
          <a href="mailto:support@barcloud.com?subject=License%20Activation%20Request"
            class="btn btn-primary commonBouttonStyle supportBtn">
            <span>
              <img class="loginIcons" src="/assets/menu/enterprise/forget-password-icon.svg" />
            </span>
            Contact Support
          </a>
        </div>
      </div>
    </div>
  </div>
</div>